import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

const Portal = ({ children, elementSelector }) => {
  if (elementSelector) {
    const element = document.querySelector(elementSelector)
    if (element) {
      return ReactDOM.createPortal(children, element)
    }
  }
  return ReactDOM.createPortal(children, document.body)
}

Portal.propTypes = {
  children: PropTypes.node.isRequired,
  elementSelector: PropTypes.string,
}

Portal.defaultTypes = {
  elementSelector: '',
}

export default Portal
